import packageJson from '../../package.json';

// ROLE CONSTANTS

export const APPROVAL_ROLES = {
  MANAGER: 'manager',
  HOC: 'hoc',
  CEO: 'ceo',
};

export const USER_ROLES = {
  SUPERADMIN: 'SUPERADMIN',
};

// APP CONSTANTS

export const DISCOUNT_TYPES = {
  PERCENTAGE: 'PERCENTAGE',
  AMOUNT: 'AMOUNT',
};

export const WO_STATUSES = {
  NEW: 'NEW',
  CREATED: 'CREATED',
  REJECTED: 'REJECTED',
  PROGRESS: 'PROGRESS',
  UPDATED: 'UPDATED',
  APPROVED: 'APPROVED',
  DISPATCH: 'DISPATCH',
  COMPLETED: 'COMPLETED',
  DELIVERED: 'DELIVERED',
  CANCELLED: 'CANCELLED',
  PM_APPROVED: 'PM_APPROVED',
  TH_APPROVED: 'TH_APPROVED',
  COO_APPROVED: 'COO_APPROVED',
  PO_RAISED: 'PO_RAISED',
  DELIVERY_UPDATED: 'DELIVERY_UPDATED',
  HOLD: 'HOLD',
};

export const LGOISTICS_STATUSES = {
  NEW: 'NEW',
  SHIPPED: 'SHIPPED',
  IN_TRANSIT: 'IN_TRANSIT',
  DELIVERED: 'DELIVERED',
  DELETED: 'DELETED',
};

export const commonMeasurementUnits = [
  'Unit',
  'Gram',
  'Kilogram',
  'Milliliter',
  'Litre',
  'Centimeter',
  'Inch',
  'Meter',
  'Box',
  'Piece',
  'Bundle',
  'Roll',
  'Tons',
  'CUM - Cubic Metre',
  'SFT - Square Feet',
  'RFT - Running feet',
  'Nos',
  'Bags',
  'CFT',
  'SET',
  'Mini Load',
  'Load',
  'Tractor',
  'Pan',
  'Length',
  'Coil',
  'Can',
];

export const commonSubMeasurementUnits = [
  'Unit',
  'Gram',
  'Kilogram',
  'Milliliter',
  'Litre',
  'Centimeter',
  'Inch',
  'Meter',
  'Box',
  'Piece',
  'Bundle',
  'Roll',
  'Tons',
  'CUM - Cubic Metre',
  'SFT - Square Feet',
  'RFT - Running feet',
  'Nos',
  'Bags',
  'CFT',
  'Coil',
  'Can',
];

export const DEFAULT_TNC = `1. All disputes are subject to local jurisdiction only.
2. Payment terms: 30 days from invoice date.
3. Delivery: As per agreed schedule.
4. Quality: As per specifications.
5. Warranty: As per manufacturer's warranty.`;

export const FILE_TYPES = {
  PROJECT_FILES: 'project_files',
  PROJECT_PICS: 'project_pics',
  TASK_FILES: 'task_files',
  PURCHASES_FILES: 'expense_files',
  SUB_TASK_FILES: 'sub_task_files',
  USER_PROFILE_PIC: 'user',
  LABOUR_FILES: 'work_summary_files',
  VEHICLE_PHOTO: 'vehicle_photo',
  VEHICLE_NUMPLATE_PHOTO: 'vehicle_numplate_photo',
  CRM_FILES:"crm_files",
  PO_PHOTOS: 'po_photos',
  LOGISTIC_PHOTO: 'logistic_photo',
  TASK_COMMENTS:"task_comments", 
SUBTASK_COMMENTS:"sub_task_comments",
CRM_MOM_FILES:"crm_mom_files",
};


export const Version = packageJson.version;